import styled from "styled-components";

export const BorderedContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${({theme}) => theme.grayDivider};
  border-radius: 8px;
  padding: 32px;
  margin: 0 20px 20px 0
`;
